import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import util from "../../../lib/util";
//Selectors
import {
  selectedAddress,
  duplexAddress,
} from "../../../selectors/ServiceAddress";
//Components
import IsOwner, { IsOwnerValidation } from "./Common/IsOwner";
import ExisitngFortisBCCustomer from "./Common/ExisitngFortisBCCustomer";
import AccountHolderInfo, {
  AccountHolderInfoValidation,
} from "./Common/AccountHolderInfo";
import BillingAddress, {
  BillingAddressValidation,
} from "./Common/BillingAddress";
import BillingMethod, { BillingMethodValidation } from "./Common/BillingMethod";
import DoubleEmail, { DoubleEmailValidation } from "../DoubleEmail";
import ProjectNotificationsEmail, {
  ProjectNotificationsEmailValidation,
} from "./Common/ProjectNotificationsEmail";
import ElectronicCommunicationfromMarketing, {
  ElectronicCommunicationfromMarketingValidation,
} from "./Common/ElectronicCommunicationfromMarketing";
class Residential extends React.Component {
  render() {
    const p = this.props;
    const lookup = window.osa.lookup.customerDetails;

    let exisitngFortisBCCustomer = (
      <ExisitngFortisBCCustomer
        name="fortisBCAccount"
        lookup={lookup.fortisBCAccount.Residential}
      />
    );
    if (p.bupaVerified && !p.bupaChecked) exisitngFortisBCCustomer = null;
    return (
      <div>
        <IsOwner
          name="isOwner"
          lookup={lookup.isOwnerResidential}
          isTwoMeter={p.isTwoMeter}
          address1={p.address1}
          address2={p.address2}
        />
        {exisitngFortisBCCustomer}
        {p.exisitngFortisBCCustomer == 1 &&
          !p.bupaVerified &&
          !p.verifyAccountRetriesExceed ? null : (
          <div className="form-group">
            <div className="row">
              {p.verifyAccountRetriesExceed ? null : (
                <div>
                  <div className="col-sm-12">
                    <AccountHolderInfo
                      name="accountHolderInfo"
                      lookup={lookup.accountHolderInfo}
                      disableMainInfo={p.bupaVerified || p.bupaCreated}
                      customerType={p.customerType}
                      {...p}
                    />
                  </div>

                  {p.hasBilling && p.pageName !== "serviceRemoval" ? (
                    <div>
                      <div className="col-sm-12">
                        <BillingAddress
                          name="billingAddress"
                          lookup={lookup.billingAddress}
                          selectedBillingAddress={p.selectedBillingAddress}
                        />
                      </div>
                      <div className="col-sm-12">
                        <BillingMethod name="billingMethod" />
                      </div>
                    </div>
                  ) : null}
                  <div className="col-sm-12">
                    <DoubleEmail
                      name="emailAddress"
                      customClass="col-md-4"
                      title={lookup.emailAddress.title}
                      required
                    />
                  </div>
                </div>
              )}
              <div className="col-sm-12">
                <ProjectNotificationsEmail
                  name="projectNotificationsEmail"
                  isSame={p.isSame}
                  retries={p.verifyAccountRetriesExceed}
                />
              </div>

              <div className="col-sm-12">
                <ElectronicCommunicationfromMarketing name="electronicCommunicationfromMarketing" />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Residential.propTypes = {
  isOwnerResidentialLookup: PropTypes.object,
  selectExisitngFortisBCResidentialCustomer: PropTypes.number,
  bupaVerified: PropTypes.bool,
  emailAddress: PropTypes.object,
};
//improve naming
// Change Bupa with a better naming
const mapStateToProps = (state) => {
  return {
    customerType: state.form.customerType,
    exisitngFortisBCCustomer: state.form.fortisBCAccount,
    selectedBillingAddress: state.form.billingAddress,
    bupaChecked: state.gas.bupaChecked,
    bupaVerified: state.form.bupaVerified,
    bupaCreated: state.gas.bupaCreated,
    isSame: state.form.projectNotificationsEmail_IsSame,
    idType: state.form.idType,
    verifyAccountRetriesExceed: state.gas.verifyAccountExceed,
    isTwoMeter:
      state.form.buildingType == "2" && state.form.duplexMeterCount == "2",
    address1: util.addressToString(selectedAddress(state)),
    address2: util.addressToString(duplexAddress(state)),
  };
};

export default connect(mapStateToProps)(Residential);

//NOTE: after every change here,Commercial component also should check for changes
export function ResidentialValidation(form, verifyExceed, hasBilling = false) {
  let toRet = [...IsOwnerValidation("isOwner")];
  if (verifyExceed)
    toRet = [
      ...toRet,
      ...ProjectNotificationsEmailValidation("projectNotificationsEmail", "0"),
      ...ElectronicCommunicationfromMarketingValidation(
        "electronicCommunicationfromMarketing"
      ),
    ];
  else {
    toRet = [
      ...toRet,
      ...AccountHolderInfoValidation("accountHolderInfo", form),
    ];
    if (hasBilling)
      toRet = [
        ...toRet,
        ...BillingAddressValidation("billingAddress", form.billingAddress),
        ...BillingMethodValidation("billingMethod", form.billingMethod),
      ];
    toRet = [
      ...toRet,
      ...DoubleEmailValidation("emailAddress"),
      ...ProjectNotificationsEmailValidation(
        "projectNotificationsEmail",
        form.projectNotificationsEmail_IsSame
      ),
      ...ElectronicCommunicationfromMarketingValidation(
        "electronicCommunicationfromMarketing"
      ),
    ];
  }
  return toRet;
}
